export interface SalesInvoiceHeader {
  id: string;
  invoiceNo: number;
  dateInvoiced: Date;
  createdBy: string;
  dateCreated: Date;
  customerKey: string;
  customerName: string;
  currencyCode: string;
  currencySymbol: string;
  invoiceStatus: string;
  overallTotal: string;
  goodsTotalNumeric: number;
  deliveryTotalNumeric: number;
  extraTotalNumeric: number;
  nettTotalNumeric: number;
  taxTotalNumeric: number;
  overallTotalNumeric: number;
  notes: string;
  creditNote: string;
  colour: string;
}
